module.exports = __webpack_public_path__ + "static/media/alarm.310f1218.jpg";